module.exports = __webpack_public_path__ + "img/nexity.da479bef.jpg";